function toggleProductGrid(lines) {
    
    const productGrid = document.querySelector('.searchtap-temp .product-list');
    
    productGrid.classList.remove('product-list--per-row-mob-2');
    productGrid.classList.remove('product-list--per-row-mob-1');
    
    if (lines === 2) {
        productGrid.classList.add('product-list--per-row-mob-2');
    } else if (lines === 1) {
        productGrid.classList.add('product-list--per-row-mob-1');
    }
    const gridButtons = document.querySelectorAll('.layout-switch');
    const currentColumns = parseInt(lines);

    gridButtons.forEach(button => {
        const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
        const isActive = button.classList.contains('layout-switch--active');

        if (buttonColumns === currentColumns && !isActive) {
            button.classList.add('layout-switch--active');
        } else if (buttonColumns !== currentColumns && isActive) {
            button.classList.remove('layout-switch--active');
        }
    });

}